/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import DistributionReport from '../components/DistributionReport';
import RevenueReport from '../components/RevenueReport';

function BplsReportsContainer({ match, pathName }) {
  const permissions = getJson('permissions');

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['E2E BPLS DISTRIBUTION REPORT']) && (
                <li className="nav-item">
                  <Link
                    to="/bpls/reports/distribution"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/reports/distribution') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Distribution
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E BPLS DETAILED REVENUE REPORT']) && (
                <li className="nav-item">
                  <Link
                    to="/bpls/reports/revenue-report"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/reports/revenue-report') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Detailed Revenue Report
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          {Acl(permissions, ['E2E BPLS DISTRIBUTION REPORT']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/distribution`} />}
            />
          )}
          {Acl(permissions, ['E2E BPLS DISTRIBUTION REPORT']) && (
            <Route
              path={`${match.path}/distribution`}
              component={DistributionReport}
            />
          )}
          {Acl(permissions, ['E2E BPLS DETAILED REVENUE REPORT']) && (
            <Route
              path={`${match.path}/revenue-report`}
              component={RevenueReport}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

BplsReportsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(BplsReportsContainer);
